<template>
  <article class="st-product">
    <!-- отдельной страницы позиции нет: фото и название не ссылки -->
    <div class="st-product__media">
      <img
        v-if="item.image && !imageFailed"
        :src="item.image"
        alt=""
        loading="lazy"
        @error="imageFailed = true"
      />
      <div v-else class="st-placeholder">
        <PageIcon />
      </div>
    </div>

    <!-- в подборке «Спецпредложения» метка не нужна: там все позиции такие -->
    <span
      v-if="item.special_offer && !hideSpecialBadge"
      class="st-tag st-product__badge"
      >Спецпредложение</span
    >

    <button
      v-if="favoritesAvailable"
      class="st-icon-btn st-product__fav"
      :class="favorite && 'is-on'"
      type="button"
      :aria-pressed="favorite"
      :aria-label="
        (favorite ? 'Убрать из избранного: ' : 'В избранное: ') + item.name
      "
      :title="favorite ? 'Убрать из избранного' : 'В избранное'"
      :disabled="pending"
      @click="toggle"
    >
      <HeartIcon :filled="favorite" />
    </button>

    <div class="st-product__body">
      <div class="st-product__title">{{ item.name }}</div>
      <div v-if="specs" class="st-note">{{ specs }}</div>
      <div class="st-product__foot">
        <span class="st-amount">{{ priceMask(item.price) }}</span>
        <!-- всегда активна: с типом предмета лизинга — онлайн-оформление,
             без него — заявка менеджеру с данными позиции (решает родитель) -->
        <ui-button
          class="st-btn st-btn--base"
          :loading="applying"
          :disabled="applying"
          @click="$emit('apply', item)"
          >Оформить онлайн</ui-button
        >
      </div>
    </div>
  </article>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PageIcon from "@/assets/svg/page.vue";
import HeartIcon from "./HeartIcon.vue";
import { priceMask, itemSpecs } from "../helpers";

export default {
  name: "ProductCard",
  components: { PageIcon, HeartIcon },
  props: {
    item: { type: Object, required: true },
    // по этой позиции сейчас оформляется заявка
    applying: Boolean,
    // скрыть метку «Спецпредложение» (в подборке спецпредложений)
    hideSpecialBadge: Boolean,
  },
  emits: ["apply", "error"],
  data() {
    return {
      imageFailed: false,
    };
  },
  computed: {
    ...mapGetters({
      favoritesAvailable: "favorites/getFavoritesAvailable",
      isFavorite: "favorites/isFavorite",
      isFavoritePending: "favorites/isFavoritePending",
    }),
    favorite() {
      return this.isFavorite(this.item.id);
    },
    pending() {
      return this.isFavoritePending(this.item.id);
    },
    specs() {
      return itemSpecs(this.item);
    },
  },
  methods: {
    ...mapActions({ toggleFavorite: "favorites/toggleFavorite" }),
    priceMask,
    async toggle() {
      const error = await this.toggleFavorite(this.item.id);
      if (error) this.$emit("error", error);
    },
  },
};
</script>
